module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'sioce49j',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
